import { render, staticRenderFns } from "./LeaderboardsForm.vue?vue&type=template&id=6dd0f2db&scoped=true&"
import script from "./LeaderboardsForm.vue?vue&type=script&lang=js&"
export * from "./LeaderboardsForm.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardsForm.vue?vue&type=style&index=0&id=6dd0f2db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd0f2db",
  null
  
)

export default component.exports